<!--
 * @FilePath: /src/components/header.vue
 * @Description: 头部
-->
<template>
  <div class="header">
    <div class="table f-cb">
      <img class="logo f-fl" src="../assets/images/logo.png" alt="logo" />
      <ul id="munu" class="munu f-cb f-fr">
        <div class="line" v-if="defaultLeft > -1" :style="{'left': `${lineLeft}px`}"></div>
        <li id="m1" ref="homeView" @mouseover="handlHover('homeView')" @mouseleave="handleMove" class="f-fl">
          <router-link :to="{ path: '/' }">首页</router-link>
        </li>
        <li id="m3" class="f-fl" ref="about" @mouseover="handlHover('about')" @mouseleave="handleMove">
          <div @click="handleRouter('about', {item: 'desc'})">关于传发</div>
          <ul class="nav" v-if="handleType === 'about'">
            <li>
              <div @click="handleRouter('about', {item: 'desc'})">公司简介</div>
            </li>
            <li>
              <div @click="handleRouter('about', {item: 'sh'})">上海中心</div>
            </li>
            <li>
              <div @click="handleRouter('about', {item: 'nc'})">南昌中心</div>
            </li>
          </ul>
        </li>
        <li id="m_news" class="f-fl" ref="news" @mouseover="handlHover('news')" @mouseleave="handleMove">
          <div @click="handleRouter('news', {item: 'list'})">新闻中心</div>
          <ul class="nav" v-if="handleType === 'news'">
            <li>
              <div @click="handleRouter('news', {item: 'list'})">公告/声明</div>
            </li>
          </ul>
        </li>
        <li id="m4" class="f-fl" ref="join" @mouseover="handlHover('join')" @mouseleave="handleMove">
          <div @click="handleRouter('join', {item: 'post'})">加入传发 </div>

          <ul class="nav" v-if="handleType === 'join'">
            <li>
              <div @click="handleRouter('join', {item: 'post'})">岗位需求</div>
            </li>
            <li>
              <div @click="handleRouter('join', {item: 'weal'})">福利待遇</div>
            </li>
            <li>
              <div @click="handleRouter('join', {item: 'shine'})">员工风采</div>
            </li>
          </ul>
        </li>
        <li id="m5" ref="contact" @mouseover="handlHover('contact')" @mouseleave="handleMove" class="f-fl">
          <router-link :to="{ path: '/contact' }">联系我们</router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'headerView',
  data() {
    return {
      handleType: '',
      lineLeft: 0,
      defaultLeft: -1
    }
  },
  created() { },
  mounted() {
    this.defaultLeft = this.$refs[this.$route.name].offsetLeft
    this.lineLeft = this.defaultLeft
  },
  methods: {
    handlHover(type = '') {
      this.lineLeft = this.$refs[type].offsetLeft
      this.handleType = type
    },
    handleMove() {
      this.handleType = ''
      this.lineLeft = this.defaultLeft
    },
    handleRouter(name, params = {}) {
      const curName = this.$route.name
      if (name === curName) {
        // this.$router.replace({
        //   name,
        //   params,
        //   replace: true
        // })
        this.$emit('same-router', params)
      } else {
        this.$router.push({
          name,
          params
        })
      }
      this.handleMove()
    }
  }
}
</script>

<style lang="stylus">
.header {
  width: 100%;
  height: 90px;

  a {
    color: #464646;
    width: 100%;
    height: 100%;
    display: inline-block;
  }

  .table {
    width: 1200px;
    height: 100%;
    margin: 0px auto;

    .logo {
      display: block;
      height: 100%;
    }

    .munu {
      position: relative;

      .line {
        width: 124px;
        height: 4px;
        background: rgb(218, 101, 65);
        position: absolute;
        z-index: -1;
        top: 86px;
        left: 0px;
        transition: left 0.5s;
      }

      .nav {
        position: absolute;
        top: 90px;
        border-radius: 2px;
        background-color: white;
        left: -30px;
        width: 178px;
        height: auto;
        text-align: center;

        a {
          color: #464646;
        }

        li {
          cursor: pointer;
          width: 100%;
          height: 45px;
          line-height: 45px;

          &:hover {
            background-color: #f7f7f7;
          }
        }

        li+li {
          border-top: 1px solid #f2f2f2;
        }
      }

      width: 620px;
      height: 100%;
      font-size: 16px;

      li {
        position: relative;
        width: 20%;
        height: 100%;
        line-height: 90px;
        text-align: center;
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue